var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 128,
    viewBox: "0 0 111 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86919 94.3617V33.6613L55.4326 3.31677L107.996 33.6613V94.3617L55.4326 124.706L2.86919 94.3617Z",
    fill: "#FEE480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4326 6.62207L105.127 35.3139V92.6976L55.4326 121.389L5.73837 92.6976V35.3139L55.4326 6.62207ZM55.4326 0L52.5634 1.65265L2.86918 30.3445L0 31.9971V96.0029L2.86918 97.6555L52.5634 126.347L55.4326 128L58.3018 126.347L107.996 97.6555L110.865 96.0029V32.0086L107.996 30.356L58.3018 1.65265L55.4326 0Z",
    fill: "#491C0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.127 92.6976L83.6195 79.9699L88.9906 44.5412L105.127 35.3139V92.6976Z",
    fill: "#D3AE4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4326 121.389L57.5214 101.076L83.6195 79.9699L105.127 92.6976L55.4326 121.389Z",
    fill: "#EAD381"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2503 78.2025L5.73837 92.6976L55.4326 121.389L57.5214 101.076L24.2503 78.2025Z",
    fill: "#D3AE4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73837 92.6976L24.2503 78.2025L22.196 40.6965L5.73837 35.3139V92.6976Z",
    fill: "#B27D2B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.196 40.6965L55.4326 24.6405L55.4326 6.62207L5.73837 35.3139L22.196 40.6965Z",
    fill: "#F0EDB3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4326 24.6405L88.9906 44.5412L105.127 35.3139L55.4326 6.62207L55.4326 24.6405Z",
    fill: "#B27D2B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.236 43.0837C57.2689 43.0837 58.1411 43.4509 58.8642 44.1854C59.5872 44.9085 59.943 45.7692 59.943 46.7906V74.4496C59.943 75.4825 59.5872 76.3547 58.8642 77.0777C58.1411 77.8008 57.2689 78.1565 56.236 78.1565C55.2031 78.1565 54.3538 77.8008 53.6308 77.0777C52.9078 76.3547 52.552 75.4825 52.552 74.4496V50.4632H51.6338C50.6009 50.4632 49.7287 50.1074 49.0057 49.3844C48.2826 48.6613 47.9269 47.8006 47.9269 46.7792C47.9269 45.7577 48.2826 44.897 49.0057 44.1739C49.7287 43.4394 50.6009 43.0722 51.6338 43.0722H56.2245L56.236 43.0837Z",
    fill: "#491C0E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPlace);
export default __webpack_public_path__ + "static/media/first-place.b14e16fe194025220614d2117305f192.svg";
export { ForwardRef as ReactComponent };